import { Instance } from "../../Base";
import Decorator from "../Decorator";
import VMasker from "vanilla-masker";

export default class MaskDecorator extends Decorator {
  constructor(component: Instance, mask: string) {
    super(component);
    try {
      const { type, value } = JSON.parse(mask);
      if (!type || !value) {
        console.error('Mask failed to load!');
        return;
      }
      (VMasker(this.component.element) as Record<string, (v: string) => void>)[`mask${type}`](value);
    } catch (_error) {
      console.error('Mask failed to load!');
    }
  }
}